import './login/login.module'
import './login-mfa/login-mfa.module'
import './set-mfa/set-mfa-page.module'
import AuthService from './auth.service'
import authForm from './auth-form/auth-form.component'
import authWarning from './auth-warning/auth-warning.component'
import StoreService from '../../common/redux/store.service'
import sso from './auth-form/sso/sso.component'

export default angular
  .module('components.auth', ['login', 'loginMfa', 'setMfaPage'])
  .component('authForm', authForm)
  .component('sso', sso)
  .component('authWarning', authWarning)
  .service('StoreService', StoreService)
  .service('AuthService', AuthService)
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('auth', {
        redirectTo: 'auth.login',
        url: '/auth',
        template: '<div ui-view></div>'
      })
    $urlRouterProvider.otherwise('/login')
  })
  .run(($transitions, $state, $auth, $window, AuthService) => {
    const { href } = $window.location
    const urlParams = new URL(href).searchParams
    const authAction = href.includes('signin') ? 'signin' : href.includes('signup') ? 'signup' : undefined

    const ssoCode = urlParams.get('code')
    const sessionState = urlParams.get('session_state')

    const error = urlParams.get('error') ?? null
    const errorDescription = urlParams.get('error_description') || ''
    const errorTrimmedDescription = `${(errorDescription).slice(0, 50)}...`
    if (authAction) {
      if (ssoCode && sessionState) {
        return AuthService.handleSsoLogin(ssoCode, sessionState, authAction)
      } else if (error) {
        return $state.go('auth.login', {
          error: errorTrimmedDescription ?? 'unknown error'
        })
      }
    }
    $transitions.onStart({ to: 'auth.**' }, () => {
      if ($auth.isAuthenticated()) {
        return $state.target('app')
      }
    })

    $transitions.onStart({ to: state => !!(state.data && state.data.requiredAuth) },
      () => {
        if (!$auth.isAuthenticated()) {
          return $state.target('auth.login')
        }
      })
  })
  .name
